var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard"}},[_c('header-vue'),_c('keep-alive',{attrs:{"exclude":['TokenUsage']}},[(_vm.showView)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }